<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span><i>Tenth Volume</i></span></p>
<p class="part-title">I<span class="smallcaps">CE</span> J<span class="smallcaps">EWEL AND</span> H<span class="smallcaps">EART OF</span> F<span class="smallcaps">IRE</span></p>
<p class="part-normal">Always are there enemies. Some at you run with knife, some smile at your side. Some you notice not till round your throat their two hands come.</p>
<p class="part-right">Inscription found on many male amulets;</p>
<p class="part-right1">the warding spell is presumably carried</p>
<p class="part-right1">by the stated facts: Vormlander</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?263d40f5